(function () {
  const COLOR = "#c68545";

  function apply() {
    const drawer =
      document.querySelector("#CartDrawer") ||
      document.querySelector(".cart__drawer") ||
      document.querySelector("[data-cart-drawer]");

    if (!drawer) return;

    const nodes = drawer.querySelectorAll(
      ".cart__item-price-col .cart__price, .cart__item-price-col small, .cart__item-price-col .cart__discount"
    );

    nodes.forEach((el) => {
      el.style.setProperty("color", COLOR, "important");
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    apply();
    const obs = new MutationObserver(apply);
    obs.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener("cart:updated", apply);
})();